import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  container: {
    margin: 10,
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    height: '95%',
  },
  nameText: {
    fontSize: 14,
  },
  containerTitle: {
    marginTop: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  containerQuestion: {
    marginTop: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  questionText: {
    fontSize: 15,
    fontWeight: 500,
  },
  answersText: {
    fontSize: 12,
    fontWeight: 700,
    marginLeft: 10,
  },
  validationCodeContainer: {
    marginTop: 18,
    alignItems: 'center',
  },
  validationCodeText: {
    fontSize: 10,
    textTransform: 'uppercase',
  },
});
